import makeStyles from 'e100-react-components/lib/styles/makeStyles';

import { BoxProps } from './ui';

interface Props extends Pick<BoxProps, 'padding'> {}

export const useStyles = makeStyles(({ spacing }) => ({
  container: ({ padding }: Props) => {
    if (!padding) {
      return {};
    }

    if (typeof padding === 'number') {
      return {
        padding: spacing(padding)
      };
    }

    return {
      ...padding.top && { paddingTop: spacing(padding.top) },
      ...padding.right && { paddingRight: spacing(padding.right) },
      ...padding.bottom && { paddingBottom: spacing(padding.bottom) },
      ...padding.left && { paddingLeft: spacing(padding.left) }
    }
  }
}));
